"use client";

import { c as _c } from "react/compiler-runtime";
import { type TextFieldProps } from "@mui/material";
import Joi from "joi";
import React, { useState } from "react";
import { useI18nContext } from "#/shared/hooks";
import { DebouncedInput } from "#/shared/ui/molecules/DebouncedInput";
type JsonInputProps = Omit<TextFieldProps, "onChange"> & {
  value: string;
  onChange: (value: string) => void;
  validationSchema: Joi.Schema;
};
export const JsonInput: React.FC<JsonInputProps> = t0 => {
  const $ = _c(15);
  let onChange;
  let restProps;
  let validationSchema;
  if ($[0] !== t0) {
    ({
      onChange,
      validationSchema,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = onChange;
    $[2] = restProps;
    $[3] = validationSchema;
  } else {
    onChange = $[1];
    restProps = $[2];
    validationSchema = $[3];
  }
  const {
    LL
  } = useI18nContext();
  const [inputError, setInputError] = useState(null);
  let t1;
  if ($[4] !== onChange || $[5] !== validationSchema) {
    t1 = value => {
      onChange(value);
      if (!value) {
        setInputError(null);
      }
      ;
      try {
        const parsed = JSON.parse(value);
        Joi.assert(parsed, validationSchema);
        setInputError(null);
      } catch (t2) {
        const e = t2;
        if (e instanceof Error) {
          setInputError(e.message);
        } else {
          setInputError("Unknown error");
          console.error(e);
        }
      }
    };
    $[4] = onChange;
    $[5] = validationSchema;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleChange = t1;
  let t2;
  if ($[7] !== LL) {
    t2 = LL.INPUT();
    $[7] = LL;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = !!inputError;
  let t4;
  if ($[9] !== handleChange || $[10] !== inputError || $[11] !== restProps || $[12] !== t2 || $[13] !== t3) {
    t4 = <DebouncedInput label={t2} placeholder="e.g.: [1,2,3,null,5]" onChange={handleChange} error={t3} helperText={inputError} fullWidth={true} {...restProps} />;
    $[9] = handleChange;
    $[10] = inputError;
    $[11] = restProps;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};